import React, {useEffect, useState} from 'react';
import Loading from 'layout/Loading';
import {useLocation} from 'react-router';
import {
    axiosInstance,
    changeAutomaticPayment,
    changePassPost,
    getServiceDetail,
    getTrafficService,
    getTrafficUsage
} from 'api/Api';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ServiceDetailUsage from './ServiceDetailUsage';
import {AdapterDateFnsJalali} from '@mui/x-date-pickers/AdapterDateFnsJalali';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {DemoItem} from '@mui/x-date-pickers/internals/demo';
import Button from '@mui/material/Button';
import moment from 'jalali-moment';
import {IoMdEyeOff} from 'react-icons/io';
import {IoEye} from 'react-icons/io5';
import {MdKeyboardArrowRight} from 'react-icons/md';
import {MdKeyboardArrowLeft} from 'react-icons/md';
import {MdContentCopy} from 'react-icons/md';
import {Chart as ChartJS, Tooltip, Legend, ArcElement} from 'chart.js';
import {Pie, Doughnut} from 'react-chartjs-2';
import Alert, {useAlert} from 'components/snacks/Alert';
import TrafficPlanSelector from "components/plan/TrafficPlanSelector";
import LoadingButton from "components/button/LoadingButton";
import BasicModal from "components/Modal/BasicModal";

ChartJS.register(Tooltip, Legend, ArcElement);

const ServiceDetail = () => {
    const [loading, setLoading] = useState(true);
    const [run, setRun] = useState(false);
    const [label, setLabel] = useState('');
    const [showLabelModal, setShowLabelModal] = useState({
        show: false,
        loading: false,
        value: ''
    });
    const [status, setStatus] = useState(1);
    const [statusText, setStatusText] = useState('');
    const [serviceInfo, setServiceInfo] = useState(false);
    const [serviceData, setServiceData] = useState();
    const [activeTab, setActiveTab] = useState('detail');
    const [attributes, setAttributes] = useState([]);
    const [specifications, setSpecifications] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showTrafficLoading, setShowTrafficLoading] = useState(true);
    const [trafficUsageLoading, setTrafficUsageLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [consoleState, setConsoleState] = useState('#');
    const location = useLocation();
    const serviceId = location.state.id;
    const [modalDetail, setModalDetail] = useState({});
    const [operation, setOperation] = useState({
        has_stop: 0,
        has_restart: 0,
        has_monitoring: 0,
        has_console: 0,
        has_statistics: 0
    });
    const [trafficPlan, setTrafficPlan] = useState([]);
    const [paymentIsChecked, setPaymentIsChecked] = useState(false)

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const handleShowModal = () => {
        setShowModal(!showModal);
    };
    const [password, setPassword] = useState(true);
    const handlePassowrd = () => {
        setPassword(!password);
    };

    // FUNCTIONS
    const Error = (text, type = 'success') => {
        alertStore.AddAlert({
            key: 'copy',
            message: text,
            severity: type,
            auto_hide: true
        });
    };

    const handleSave = (e) => {
        navigator.clipboard.writeText(e.value);
        Error('با موفقیت کپی شد', 'success');
    };
    const restartService = () => {
        const formData = new FormData();
        formData.append('service_id', serviceId);
        axiosInstance()
            .post('reset-server', formData)
            .then((r) => {
                if (r.data.status === 200) {
                    Error('با موفقیت انجام شد', 'success');
                    setRun(false);
                    setStatus(3);
                } else {
                    Error(r.data.msg, 'error');
                }
            })
            .catch(() => {
                Error('مشکلی پیش آمد، لطفا دوباره امتحان کنید', 'error');
            })
            .finally(() => {
                setModalDetail({...modalDetail, loading: false, show: false});
            });
    };

    const startService = () => {
        const formData = new FormData();
        formData.append('service_id', serviceId);
        axiosInstance()
            .post('start-server', formData)
            .then((r) => {
                if (r.data.status === 200) {
                    Error('با موفقیت فعال شد', 'success');
                    setRun(true);
                    setStatus(1);
                } else {
                    Error(r.data.msg, 'error');
                }
            })
            .catch(() => {
                Error('مشکلی پیش آمد، لطفا دوباره امتحان کنید', 'error');
            })
            .finally(() => {
                setModalDetail({...modalDetail, loading: false, show: false});
            });
    };

    const stopService = () => {
        const formData = new FormData();
        formData.append('service_id', serviceId);
        axiosInstance()
            .post('stop-server', formData)
            .then((r) => {
                if (r.data.status === 200) {
                    Error('با موفقیت متوقف انجام شد', 'success');
                    setRun(false);
                    setStatus(2);
                } else {
                    Error('توقف سرویس با خطا مواجه شد', 'error');
                }
            })
            .catch(() => {
                Error('مشکلی پیش آمد، لطفا دوباره امتحان کنید', 'error');
            })
            .finally(() => {
                setModalDetail({...modalDetail, loading: false, show: false});
            });
    };

    const handleModal = (type, finalSubmit = false) => {
        switch (type) {
            case 'restart': {
                if (finalSubmit) {
                    restartService();
                    setModalDetail({...modalDetail, loading: true});
                } else {
                    setModalDetail({
                        show: true,
                        title: 'restart',
                        type: 'restart',
                        message: 'آیا از اجرای دوباره سرویس خود مطمئن هستید؟'
                    });
                }
                break;
            }
            case 'start': {
                if (finalSubmit) {
                    startService();
                    setModalDetail({...modalDetail, loading: true});
                } else {
                    setModalDetail({
                        show: true,
                        title: 'start',
                        type: 'start',
                        message: 'آیا از اجرای سرویس خود مطمئن هستید؟'
                    });
                }
                break;
            }
            case 'stop': {
                if (finalSubmit) {
                    stopService();
                    setModalDetail({...modalDetail, loading: true});
                } else {
                    setModalDetail({
                        show: true,
                        title: 'stop',
                        type: 'stop',
                        message: 'آیا از متوقف کردن سرویس خود مطمئن هستید؟'
                    });
                }
                break;
            }
            default: {
                setModalDetail({
                    show: false,
                    title: '',
                    type: '',
                    message: ''
                });
                break;
            }
        }
    };

    const getStatus = (c_status) => {
        const option = {
            1: <td className={'p-5 text-success'}>موفق</td>,
            0: <td className={'p-5 text-danger'}>ناموفق</td>
        };
        return option[parseInt(c_status)];
    };

    const getStatusColor = () => {
        switch (status) {
            case 1: {
                return 'success';
            }
            case 2: {
                return 'danger';
            }
            case 3: {
                return 'warning';
            }
            default: {
                return 'danger';
            }
        }
    };

    const editLabel = (e) => {
        e.preventDefault();
        setShowLabelModal({...showLabelModal, loading: true});
        const formData = new FormData();
        formData.append('service_id', serviceId);
        formData.append('label', showLabelModal.value ? showLabelModal.value : '');
        axiosInstance()
            .post('set-server-label', formData)
            .then((value) => {
                if (value.data.status === 200) {
                    setLabel(showLabelModal.value);
                    setShowLabelModal({...showLabelModal, loading: false, show: false});
                    return Error(value.data.msg, 'success');
                } else {
                    return Error(value.data.msg, 'error');
                }
            });
    };

    // MOUNTED
    useEffect(() => {
        setLoading(true);
        getServiceDetail(serviceId, (isOk, data) => {
            if (isOk) {
                setServiceData(data)
                setServiceInfo(data?.service_info);
                setAttributes(data?.attributes);
                setSpecifications(data?.specifications);
                setLogs(data?.actions_log);
                setConsoleState(data?.server_console);
                setStatusText(data?.server_status);
                setLabel(data?.user_label);
                setShowLabelModal({...showLabelModal, value: data?.user_label});
                setOperation(data?.operations);
                setTrafficPlan(data?.plans);
                setPaymentIsChecked(data.service_info.auto_pay)
                console.log(data.service_info.auto_pay)
                //
                switch (parseInt(data?.server_status_no)) {
                    case 1: {
                        setRun(true);
                        setStatus(1);
                        break;
                    }
                    case 2: {
                        setRun(false);
                        setStatus(2);
                        break;
                    }
                    case 3: {
                        setRun(false);
                        setStatus(3);
                        break;
                    }
                    default: {
                        setRun(false);
                        setStatus(2);
                        break;
                    }
                }
            }
            setLoading(false);
        });
    }, []);

    const [traffic, setTraffic] = useState({upload: 0, download: 0, total: 0});
    const [trafficUsage, setTrafficUsage] = useState({upload: 0, download: 0, total: 0});
    const [trafficInfo, setTrafficInfo] = useState();
    const [timeInfo, setTimeInfo] = useState({from_time: '', to_time: ''});
    const [startDateText, setStartDateText] = useState(location.state.st_date);
    const [endDateText, setEndDateText] = useState(location.state.ex_date);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [paymentIsCheckedModal, setPaymentIsCheckedModal] = useState(false)

    useEffect(() => {
        if (activeTab === 'traffic') {
            let item = {
                id: serviceId,
                st: '',
                ex: ''
            };
            getTrafficService(item, (isOk, data) => {
                if (isOk) {
                    setShowTrafficLoading(false);
                    setTraffic(data.used_traffic);
                    setTrafficInfo(data?.traffic_info);
                    setTimeInfo(data?.timing);
                }
            });
        }
    }, [activeTab]);

    const handleTraffic = () => {
        setTrafficUsageLoading(true)
        let item = {
            id: serviceId,
            st: startDate,
            ex: endDate + 86390000
        };
        getTrafficUsage(item, (isOk, data) => {
            if (isOk) {
                setTrafficUsage(data.used_traffic);
                setStartDateText(moment(startDate).format('jYYYY/jM/jD'));
                setEndDateText(moment(endDate).format('jYYYY/jM/jD'));
                setTimeout(() => {
                    setTrafficUsageLoading(false)
                }, 1000);
            } else {
                setTrafficUsageLoading(false)
            }
        });
    };
    const [selectedPlan, setSelectedPlan] = useState("");
    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan); // Store the selected plan
    };

    const [loadingBtn, setLoadingBtn] = useState(false)
    const handlePurchase = () => {
        if (selectedPlan) {
            const formData = new FormData();
            formData.append("service_id", serviceId);
            formData.append("plan_id", selectedPlan);
            setLoadingBtn(true)
            axiosInstance().post("buy-traffic-package", formData).then((r) => {
                if (r.data.status === 200) {
                    Error(r.data.msg, "success");
                    setTimeout(() => {
                        window.location.href = `https://panel.zaminhost.com/factors/payment/${r.data.invoice_no}/`;
                        setLoadingBtn(false)
                    }, 1000)
                } else {
                    Error(r.data.msg, "error")
                    setTimeout(() => {
                        setLoadingBtn(false)
                    }, 1000)
                }
            }).catch((e) => {
                console.log(e)
                setTimeout(() => {
                    setLoadingBtn(false)
                }, 1000)
                Error("مشکلی پیش آمد، لطفا دوباره امتحان کنید", "error");
            }).finally(() => {
                setModalDetail({...modalDetail, loading: false, show: false});
            })
        }
    };

    const handlePaymentIsChecked = () => {
        setPaymentIsCheckedModal(true)
    }
    const handleChangeAutomaticPayment = () => {
        setLoadingBtn(true)
        const formData = new FormData();
        formData.append('service_id', serviceInfo?.service_id);
        formData.append('auto_pay', !paymentIsChecked);
        changeAutomaticPayment(formData, (isOk, data) => {
            if (isOk) {
                alertStore.AddAlert({
                    key: '200',
                    message: data,
                    severity: 'success',
                    auto_hide: true
                });
                setPaymentIsChecked(!paymentIsChecked)
                setPaymentIsCheckedModal(false)
                setLoadingBtn(false)
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
                setPaymentIsCheckedModal(false)
                setLoadingBtn(false)
            }
        });
    }
    return (
        <>
            {loading ? (
                <Loading/>
            ) : (
                <>
                    {
                        serviceData?.used_traffic_percent > 90 ? (
                            <div
                                className={`px-4 py-3 mb-4 rounded-lg d-flex align-items-center flex-lg-row border-1 justify-content-between flex-column 
                                ${serviceData?.used_traffic_percent > 99 ? 'text-danger' : 'text-warning'}`}
                                style={{
                                    background: serviceData?.used_traffic_percent > 99 ? 'rgba(248, 40, 90, 0.2)' : 'rgba(255, 199, 0, 0.2)',
                                    borderColor: serviceData?.used_traffic_percent > 99 ? 'rgb(248, 40, 90)' : 'rgb(255, 199, 0)'
                                }}
                            >
                                <p className="mb-0 f-11">شما بیش از {serviceData?.used_traffic_percent} درصد از ترافیک
                                    خود را مصرف کرده اید، لطفا برای خرید ترافیک اقدام نمایید.</p>
                                <button type={'button'}
                                        className={`btn ${serviceData?.used_traffic_percent > 99 ? 'btn-danger' : 'btn-warning'} fw-semibold me-2`}
                                        onClick={handleShowModal}>
                                    خرید ترافیک
                                </button>
                            </div>
                        ) : ('')
                    }

                    <div className="card mb-6">
                        <div className="relative card-body pt-9 px-lg-9 pb-0 px-4 overflow-hidden">
                            <div className="d-flex flex-wrap flex-sm-nowrap">
                                <div className="me-7 mb-4">
                                    <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                        <img
                                            src="https://zaminhost.com/viewDist/images/logo-org.png"
                                            alt="image"
                                        />
                                        <div
                                            className={`position-absolute translate-middle bottom-0 start-100 mb-6 bg-${getStatusColor()} rounded-circle border border-4 border-white h-20px w-20px`}
                                        ></div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                        <div className="d-flex flex-column">
                                            <div className="d-flex align-items-center justify-content-center mb-2">
                                                <p className="text-gray-900 text-hover-primary fs-2 fw-bolder m-0 me-1">
                                                    {location.state.name}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="d-flex my-4">
                                            {operation.has_stop ? (
                                                <>
                                                    {run ? (
                                                        <button
                                                            onClick={() => handleModal('stop')}
                                                            className="btn btn-sm btn-danger me-2 d-flex justify-content-center align-items-center"
                                                        >
                                                            <span className="me-2">Stop</span>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                fill="currentColor"
                                                                className="bi bi-stop-circle"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path
                                                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                                <path
                                                                    d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3z"/>
                                                            </svg>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleModal('start')}
                                                            className="btn btn-sm btn-success me-2 d-flex justify-content-center align-items-center"
                                                        >
                                                            <span className="me-2">Run</span>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                fill="currentColor"
                                                                className="bi bi-play"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path
                                                                    d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"/>
                                                            </svg>
                                                        </button>
                                                    )}
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                            {operation.has_restart ? (
                                                <button
                                                    onClick={() => handleModal('restart')}
                                                    className="btn btn-sm btn-primary me-2 d-flex justify-content-center align-items-center"
                                                >
                                                    <span className="me-2">Restart</span>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-arrow-clockwise"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                        />
                                                        <path
                                                            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                                    </svg>
                                                </button>
                                            ) : (
                                                <></>
                                            )}
                                            {operation.has_console ? (
                                                <>
                                                    {consoleState === '#' ? (
                                                        <>
                                                            <button
                                                                className="btn btn-sm btn-info me-2 d-flex justify-content-center align-items-center cursor-not-allowed">
                                                                <span className="me-2">Console</span>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-terminal"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        d="M6 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 9zM3.854 4.146a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"/>
                                                                    <path
                                                                        d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12z"/>
                                                                </svg>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <a
                                                                href={consoleState}
                                                                target="_blank"
                                                                className="btn btn-sm btn-info me-2 d-flex justify-content-center align-items-center"
                                                            >
                                                                <span className="me-2">Console</span>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-terminal"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        d="M6 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 9zM3.854 4.146a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"/>
                                                                    <path
                                                                        d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12z"/>
                                                                </svg>
                                                            </a>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                    {/* ************ edit modal ************ */}
                                    {showLabelModal.show && (
                                        <>
                                            <div className="modal fade show d-block" id="submitModal">
                                                <form
                                                    method={'post'}
                                                    onSubmit={editLabel}
                                                    className="modal-dialog"
                                                >
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h1
                                                                className="modal-title fs-5"
                                                                id="exampleModalLabel"
                                                            >
                                                                ویرایش عنوان
                                                            </h1>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                onClick={() =>
                                                                    setShowLabelModal({
                                                                        ...showLabelModal,
                                                                        show: false
                                                                    })
                                                                }
                                                            ></button>
                                                        </div>
                                                        {showLabelModal.loading ? (
                                                            <>
                                                                <div className="modal-body">
                                                                    <div
                                                                        className={
                                                                            'd-flex justify-content-center align-items-center'
                                                                        }
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                marginLeft: '15px'
                                                                            }}
                                                                        >
                                                                            <CircularProgress/>
                                                                        </Box>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="modal-body">
                                                                    <input
                                                                        type="text"
                                                                        className={'form-control'}
                                                                        placeholder={'عنوان سرویس'}
                                                                        value={
                                                                            showLabelModal.value
                                                                                ? showLabelModal.value
                                                                                : ''
                                                                        }
                                                                        onChange={(e) =>
                                                                            setShowLabelModal({
                                                                                ...showLabelModal,
                                                                                value: e.target.value
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            setShowLabelModal({
                                                                                ...showLabelModal,
                                                                                show: false
                                                                            })
                                                                        }
                                                                        className="btn btn-secondary"
                                                                        data-bs-dismiss="modal"
                                                                    >
                                                                        بستن
                                                                    </button>
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-primary"
                                                                    >
                                                                        ویرایش
                                                                    </button>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-backdrop fade show"></div>
                                        </>
                                    )}
                                    {/* ************ start modal ************ */}
                                    {modalDetail.show && (
                                        <>
                                            <div className="modal fade show d-block" id="submitModal">
                                                <div className="modal-dialog">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h1
                                                                className="modal-title fs-5"
                                                                id="exampleModalLabel"
                                                            >
                                                                {modalDetail.title}
                                                            </h1>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                onClick={() =>
                                                                    setModalDetail({
                                                                        ...modalDetail,
                                                                        show: false
                                                                    })
                                                                }
                                                            ></button>
                                                        </div>
                                                        {modalDetail.loading ? (
                                                            <>
                                                                <div className="modal-body">
                                                                    <div
                                                                        className={
                                                                            'd-flex justify-content-center align-items-center'
                                                                        }
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                marginLeft: '15px'
                                                                            }}
                                                                        >
                                                                            <CircularProgress/>
                                                                        </Box>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="modal-body">
                                                                    {modalDetail.message}
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            setModalDetail({
                                                                                ...modalDetail,
                                                                                show: false
                                                                            })
                                                                        }
                                                                        className="btn btn-secondary"
                                                                        data-bs-dismiss="modal"
                                                                    >
                                                                        خیر
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            handleModal(modalDetail.type, true)
                                                                        }
                                                                        className="btn btn-primary"
                                                                    >
                                                                        بله مطمئن هستم.
                                                                    </button>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-backdrop fade show"></div>
                                        </>
                                    )}
                                    {/* ************ end modal ************ */}
                                    <div className="d-flex flex-wrap flex-stack">
                                        <div className="d-flex flex-column flex-grow-1 pe-8">
                                            <div className="d-flex flex-wrap">
                                                <div
                                                    className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center" style={{
                                                        height: '35px'
                                                    }}>
                                                        <div
                                                            className="fs-2 fw-bolder"
                                                            data-kt-countup="true"
                                                            data-kt-countup-value="4500"
                                                            data-kt-countup-prefix="$"
                                                        >
                                                            {'#' + serviceInfo?.service_id}
                                                        </div>
                                                    </div>
                                                    <div className="fw-bold fs-6 text-gray-400 mt-3">
                                                        شماره سرویس
                                                    </div>
                                                </div>
                                                <div
                                                    className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="fs-2 fw-bolder"
                                                            data-kt-countup="true"
                                                            data-kt-countup-value="4500"
                                                            data-kt-countup-prefix="$">
                                                            {label ? label : 'بدون نام'}
                                                        </div>
                                                        <button
                                                            className={'btn btn-warning ms-5'}
                                                            style={{
                                                                width: '35px',
                                                                height: '35px',
                                                                padding: '5px'
                                                            }}
                                                            onClick={() =>
                                                                setShowLabelModal({
                                                                    ...showLabelModal,
                                                                    show: true
                                                                })
                                                            }
                                                        >
                                                            <i className={'bi bi-pen ms-2 f-1'}></i>
                                                        </button>
                                                    </div>
                                                    <div className="fw-bold fs-6 text-gray-400 mt-3">
                                                        نام سرویس
                                                    </div>
                                                </div>
                                                <div
                                                    className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="fs-2 fw-bolder "
                                                            data-kt-countup="true"
                                                            data-kt-countup-value="80"
                                                        >
                                                            <div className="switch_checkbox">
                                                                <label>
                                                                    <input id="switch_checkbox" checked={paymentIsChecked} onChange={handlePaymentIsChecked} type="checkbox"/>
                                                                    <span></span>{!paymentIsChecked ? (
                                                                    <div className={'text-danger'}>غیر فعال</div>
                                                                ) : (
                                                                    <div className={'text-success'}>فعال</div>
                                                                )}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-bold fs-6 text-gray-400 mt-3">پرداخت خودکار سرویس</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className="m-0">وضعیت‌ : </p>
                                                <p
                                                    className={`m-0 ms-5 badge badge-light-${getStatusColor()}`}
                                                >
                                                    {statusText}
                                                </p>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-2">
                                                <p className="m-0">تاریخ شروع : </p>
                                                <p className="m-0 ms-5">{location.state.st_date}</p>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-2">
                                                <p className="m-0">تاریخ سررسید : </p>
                                                <p className="m-0 ms-5">{location.state.ex_date}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ul className="carousel nav nav-stretch d-flex flex-lg-wrap flex-nowrap nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder mt-5 no-scrollbar">
                                <li
                                    className="title-slider nav-item flex-lg-grow-1 m-0 px-4 white-space-nowrap"
                                    role="presentation"
                                >
                                    <button
                                        onClick={() => setActiveTab('detail')}
                                        className={`nav-link bg-transparent d-flex justify-content-center align-items-center text-center m-0 w-100 ${
                                            activeTab === 'detail' ? 'active' : ''
                                        }`}
                                    >
                                        اطلاعات
                                    </button>
                                </li>
                                <li
                                    className="title-slider nav-item flex-lg-grow-1 m-0 px-4 white-space-nowrap"
                                    role="presentation"
                                >
                                    <button
                                        onClick={() => setActiveTab('technical')}
                                        className={`nav-link bg-transparent d-flex justify-content-center align-items-center text-center m-0 w-100 ${
                                            activeTab === 'technical' ? 'active' : ''
                                        }`}
                                    >
                                        ویژگی های فنی
                                    </button>
                                </li>
                                <li
                                    className="title-slider nav-item flex-lg-grow-1 m-0 px-4 white-space-nowrap"
                                    role="presentation"
                                >
                                    <button
                                        onClick={() => setActiveTab('service')}
                                        className={`nav-link bg-transparent d-flex justify-content-center align-items-center text-center m-0 w-100 ${
                                            activeTab === 'service' ? 'active' : ''
                                        }`}
                                    >
                                        مشخصات سرویس
                                    </button>
                                </li>
                                <li
                                    className="title-slider nav-item flex-lg-grow-1 m-0 px-4 white-space-nowrap"
                                    role="presentation"
                                >
                                    <button
                                        onClick={() => setActiveTab('history')}
                                        className={`nav-link bg-transparent d-flex justify-content-center align-items-center text-center m-0 w-100 ${
                                            activeTab === 'history' ? 'active' : ''
                                        }`}
                                    >
                                        تاریخچه عملیات
                                    </button>
                                </li>
                                <li
                                    className="title-slider nav-item flex-lg-grow-1 m-0 px-4 white-space-nowrap"
                                    role="presentation"
                                >
                                    <button
                                        onClick={() => setActiveTab('monitoring')}
                                        className={`nav-link bg-transparent d-flex justify-content-center align-items-center text-center m-0 w-100 ${
                                            activeTab === 'monitoring' ? 'active' : ''
                                        }`}
                                    >
                                        مانیتورینگ
                                    </button>
                                </li>
                                <li
                                    className="title-slider nav-item flex-lg-grow-1 m-0 px-4 white-space-nowrap"
                                    role="presentation"
                                >
                                    <button
                                        onClick={() => setActiveTab('traffic')}
                                        className={`nav-link bg-transparent d-flex justify-content-center align-items-center text-center m-0 w-100 ${
                                            activeTab === 'traffic' ? 'active' : ''
                                        }`}
                                    >
                                        ترافیک
                                    </button>
                                </li>
                                {/* <div className="arrow-slider-left arrows">
                  <MdKeyboardArrowLeft />
                </div>
                <div className="arrow-slider-right arrows">
                  <MdKeyboardArrowRight />
                </div> */}
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className={`card px-4 ${activeTab === 'detail' ? '' : 'd-none'}`}
                        >
                            <div className={`card-body px-lg-9 px-4`}>
                                <h2 className="f-2 mb-5">اطلاعات سرویس</h2>
                                <div className={'d-none d-md-block'}>
                                    <table className="table table-responsive">
                                        <tbody>
                                        <tr className="border-bottom fs-6 fw-bolder text-muted">
                                            <td
                                                className="p-5 text-center"
                                                style={{whiteSpace: 'nowrap'}}
                                            >
                                                تعداد پردازنده
                                            </td>
                                            <td className="text-dark text-center">
                                                {serviceInfo?.cpu}
                                            </td>
                                        </tr>
                                        <tr className="border-bottom fs-6 fw-bolder text-muted">
                                            <td className="p-5 text-center">RAM</td>
                                            <td className="text-dark text-center">
                                                {serviceInfo?.ram}
                                            </td>
                                        </tr>
                                        <tr className="border-bottom fs-6 fw-bolder text-muted">
                                            <td className="p-5 text-center">دیتاسنتر</td>
                                            <td className="text-dark text-center">
                                                {serviceInfo?.data_center}
                                            </td>
                                        </tr>
                                        <tr className="border-bottom fs-6 fw-bolder text-muted">
                                            <td className="min-w-90px pe-lg-6 p-5 text-center">
                                                هارد
                                            </td>
                                            <td className="fs-6 pe-lg-6 text-dark text-center">
                                                {serviceInfo?.hard_space}
                                            </td>
                                        </tr>
                                        <tr className="border-bottom fs-6 fw-bolder text-muted">
                                            <td className="min-w-90px pe-lg-6 p-5 text-center">
                                                ترافیک
                                            </td>
                                            <td className="fs-6 pe-lg-6 text-dark text-center">
                                                {serviceInfo?.traffic}
                                            </td>
                                        </tr>
                                        <tr className="border-bottom fs-6 fw-bolder text-muted">
                                            <td className="min-w-90px pe-lg-6 p-5 text-center">
                                                پورت اتصال
                                            </td>
                                            <td className="fs-6 pe-lg-6 text-dark text-center">
                                                {serviceInfo?.connection_port}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-md-none">
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <p className="m-0">تعداد پردازنده :</p>
                                        <p className="m-0 fw-bold">{serviceInfo?.cpu}</p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <p className="m-0">RAM :</p>
                                        <p className="m-0 fw-bold">{serviceInfo?.ram}</p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <p className="m-0">دیتاسنتر :</p>
                                        <p className="m-0 fw-bold">{serviceInfo?.data_center}</p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <p className="m-0">هارد :</p>
                                        <p className="m-0 fw-bold">{serviceInfo?.hard_space}</p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <p className="m-0">ترافیک :</p>
                                        <p className="m-0 fw-bold">{serviceInfo?.traffic}</p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p className="m-0">پورت اتصال :</p>
                                        <p className="m-0 fw-bold">
                                            {serviceInfo?.connection_port}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Technical Information*/}
                        <div
                            className={`card px-4 ${
                                activeTab === 'technical' ? '' : 'd-none'
                            }`}
                        >
                            <div className={`card-body px-lg-9 px-4`}>
                                <h2 className="f-2 mb-5">ویژگی های فنی</h2>

                                <div>
                                    <div className={'d-none d-md-block'}>
                                        <table className="table table-responsive">
                                            <tbody>
                                            {attributes?.map((e, index) => (
                                                <tr
                                                    key={index}
                                                    className="border-bottom fs-6 fw-bolder text-muted"
                                                >
                                                    <td
                                                        className="p-5 text-center"
                                                        style={{whiteSpace: 'nowrap'}}
                                                    >
                                                        {e?.attr_title}
                                                    </td>
                                                    <td className="text-dark text-center">
                                                        {e?.attr_value}
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-md-none">
                                        {attributes?.map((e, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center mb-5"
                                                >
                                                    <p className="m-0">{e?.attr_title}</p>
                                                    <p className="m-0 fw-bold">{e?.attr_value}</p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Service Information*/}

                        <div
                            className={`card px-4 ${activeTab === 'service' ? '' : 'd-none'}`}
                        >
                            <div className={`card-body px-lg-9 px-4`}>
                                <h2 className="f-2 mb-5">مشخصات سرویس</h2>

                                <div>
                                    <div className={'d-none d-md-block'}>
                                        <table className="table table-responsive">
                                            <tbody>
                                            {specifications?.map((e, index) => (
                                                <tr
                                                    key={index}
                                                    className="border-bottom fs-6 fw-bolder text-muted grid-3"
                                                >
                                                    <td
                                                        className="p-5 text-center"
                                                        style={{whiteSpace: 'nowrap'}}
                                                    >
                                                        {e?.spec_name}
                                                    </td>
                                                    <td className="text-dark text-center td-pass ">
                                                        <div className="hide-pass">
                                                            {e?.spec_id === 3 && password
                                                                ? '**********************'
                                                                : e?.value}
                                                        </div>
                                                    </td>
                                                    <td className="copy-pass p-5 text-center">
                                                        {e?.spec_id === 3 && (
                                                            <div className="pass" onClick={handlePassowrd}>
                                                                {password ? <IoEye/> : <IoMdEyeOff/>}
                                                            </div>
                                                        )}
                                                        <div
                                                            className="copy"
                                                            onClick={() => {
                                                                e?.spec_id === 1
                                                                    ? handleSave(e)
                                                                    : e?.spec_id === 2
                                                                        ? handleSave(e)
                                                                        : e?.spec_id === 3 && handleSave(e);
                                                            }}
                                                        >
                                                            <MdContentCopy/>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-md-none">
                                        {specifications?.map((e, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center mb-5"
                                                >
                                                    <p className="m-0">{e?.spec_name}</p>
                                                    <p className="m-0 fw-bold">{e?.value}</p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* History*/}
                        <div
                            className={`card px-4 ${activeTab === 'history' ? '' : 'd-none'}`}
                        >
                            <div className={`card-body px-lg-9 px-4`}>
                                <h2 className="f-2 mb-5">تاریخچه عملیات</h2>
                                <table className="table table-responsive">
                                    <thead>
                                    <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        <th className="row">ردیف</th>
                                        <th>تاریخ</th>
                                        <th>عملیات</th>
                                        <th>وضعیت</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {logs?.map((log, index) => (
                                        <tr
                                            key={index}
                                            className="border-bottom fs-6 fw-bolder text-muted"
                                        >
                                            <td className="text-dark number-row p-5">
                                                {index + 1}
                                            </td>
                                            <td className="p-5">{log.action_time}</td>
                                            <td className="p-5 ">{log.action}</td>
                                            {getStatus(log.status)}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Monitoring Reports*/}
                        <div
                            className={`card px-4 ${
                                activeTab === 'monitoring' ? '' : 'd-none'
                            }`}
                        >
                            {operation.has_monitoring ? (
                                <section className="card-body px-lg-9 px-4">
                                    <h2 className="f-2 mb-5">مانیتورینگ سرویس</h2>
                                    <ServiceDetailUsage serviceId={serviceId} loading={loading}/>
                                </section>
                            ) : (
                                <></>
                            )}
                        </div>
                        {/* Traffic Reports*/}
                        <div
                            className={`card px-4 ${activeTab === 'traffic' ? '' : 'd-none'}`}
                        >
                            <div className="card-body px-lg-9 px-4">
                                <div className="d-flex justify-content-between flex-lg-row flex-column mb-30">
                                    <h2 className="f-2 mb-5">ترافیک در دسترس</h2>
                                    {!serviceData?.is_unlimited ? (
                                        <Button
                                            variant="contained"
                                            onClick={handleShowModal}
                                            sx={{
                                                height: '50px',
                                                paddingRight: '20px',
                                                paddingLeft: '20px'
                                            }}
                                        >
                                            خرید ترافیک
                                        </Button>
                                    ) : ''}
                                </div>
                                <div className="d-flex gap-6 flex-lg-row flex-column position-relative">
                                    <div
                                        className="p-8 rounded bg-success shadow-gradiant flex-grow-1 flex-center-justify-between">
                                        <span className="white-color f-12">ترافیک دوره:</span>
                                        {showTrafficLoading ? (
                                            <CircularProgress/>
                                        ) : (
                                            <div
                                                className="d-flex align-items-baseline gap-2 white-color fw-bolder f-14">
                                                <b className="fw-bolder f-14">{trafficInfo?.initial === 0
                                                    ? 'نامحدود'
                                                    : trafficInfo?.initial}</b>
                                                <span className="fw-bolder f-14">
                          {trafficInfo?.initial === 0 ? '' : 'گیگابایت'}
                        </span>
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="p-8 rounded bg-primary shadow-gradiant flex-grow-1 flex-center-justify-between">
                                        <span className="white-color f-12">مازاد خریداری شده:</span>
                                        {showTrafficLoading ? (
                                            <CircularProgress/>
                                        ) : (
                                            <div
                                                className="d-flex align-items-baseline gap-2 white-color fw-bolder f-14">
                                                <b className="fw-bolder f-14">
                                                    {trafficInfo?.additional}
                                                </b>
                                                <span className="fw-bolder f-14">گیگابایت</span>
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="p-8 rounded bg-danger shadow-gradiant flex-grow-1 flex-center-justify-between">
                                        <span className="white-color f-12">مجموع:</span>
                                        {showTrafficLoading ? (
                                            <CircularProgress/>
                                        ) : (
                                            <div
                                                className="d-flex align-items-baseline gap-2 white-color fw-bolder f-14">
                                                <b className="fw-bolder f-14">
                                                    {trafficInfo?.initial === 0
                                                        ? 'نامحدود'
                                                        : parseFloat(
                                                            parseFloat(trafficInfo?.initial) +
                                                            parseFloat(trafficInfo?.additional)
                                                        )}
                                                </b>
                                                <span className="fw-bolder f-14">
                          {trafficInfo?.initial === 0 ? '' : 'گیگابایت'}
                        </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {activeTab === 'traffic' && (
                            <div className="traffic-chart ">
                                <div className="remaining-traffic-chart">
                                    <div>
                                        <h2>ترافیک باقی مانده</h2>
                                    </div>
                                    <div className="remaining-traffic-chart-content">
                                        <div className="doughnut-chart-remaining">
                                            <Doughnut
                                                data={{
                                                    labels: ['مصرف شده', 'باقی مانده'],
                                                    datasets: [
                                                        {
                                                            data: [
                                                                trafficInfo?.initial === 0 ? 0 : traffic?.total,
                                                                trafficInfo?.initial === 0
                                                                    ? 100
                                                                    : Math.round(
                                                                        parseFloat(trafficInfo?.initial) +
                                                                        parseFloat(trafficInfo?.additional) -
                                                                        parseFloat(traffic?.total)
                                                                    )
                                                            ],
                                                            backgroundColor: ['#dddddd', '#50CD89'],
                                                            borderColor: ['#dddddd', '#50CD89']
                                                        }
                                                    ]
                                                }}
                                                options={{
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            position: 'left',
                                                            labels: {
                                                                usePointStyle: true,
                                                                pointStyle: 'circle',
                                                                padding: 20,
                                                                boxWidth: 5,
                                                                boxHeight: 5
                                                            },
                                                            rtl: true
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="download-upload pl-90">
                                        <div>مصرف شده:<span
                                            className="direction-ltr">{' ' + Math.round(traffic?.total) + ' گیگ'}</span>
                                        </div>
                                        <div>باقی مانده:
                                            <span className="direction-ltr bold">
                         {' ' + (trafficInfo?.initial === 0 ? 'نامحدود' :
                             Math.round(
                                 parseFloat(trafficInfo?.initial) +
                                 parseFloat(trafficInfo?.additional) -
                                 parseFloat(traffic?.total)
                             ) +
                             ' گیگ')}
                      </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="usage-traffic-chart">
                                    <div>
                                        <h2>میزان استفاده</h2>
                                    </div>
                                    <div className="usage-traffic-chart-content">
                                        <div>
                                            <p>
                                                میزان ترافیک دانلود و آپلود در بازه {timeInfo.from_time} تا
                                                {timeInfo.to_time}
                                            </p>
                                            <div>
                                                <h3 className="pt-20">گزارش براساس:</h3>
                                                <div className="usage-traffic-chart-content-date w-100">
                                                    <div dir="rtl" className="text-right">
                                                        <LocalizationProvider
                                                            dateAdapter={AdapterDateFnsJalali}
                                                        >
                                                            <DemoItem label={'تاریخ شروع'}>
                                                                <DatePicker
                                                                    onChange={(selectedDate) => {
                                                                        const timestamp = selectedDate.getTime();
                                                                        setStartDate(timestamp);
                                                                    }}
                                                                />
                                                            </DemoItem>
                                                        </LocalizationProvider>
                                                    </div>
                                                    <div dir="rtl" className="text-right">
                                                        <LocalizationProvider
                                                            dateAdapter={AdapterDateFnsJalali}
                                                        >
                                                            <DemoItem label={'تاریخ پایان'}>
                                                                <DatePicker
                                                                    onChange={(selectedDate) => {
                                                                        const timestamp = selectedDate.getTime();
                                                                        setEndDate(timestamp);
                                                                    }}
                                                                />
                                                            </DemoItem>
                                                        </LocalizationProvider>
                                                    </div>
                                                </div>
                                                <div dir="rtl">
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleTraffic}
                                                        sx={{
                                                            height: '50px',
                                                            paddingRight: '20px',
                                                            paddingLeft: '20px'
                                                        }}
                                                    >
                                                        {trafficUsageLoading ?
                                                            <CircularProgress size={24} color="inherit"/> : 'بررسی'}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="doughnut-chart">
                                                <Pie
                                                    data={{
                                                        labels: ['دانلود', 'آپلود'],
                                                        datasets: [
                                                            {
                                                                data: [
                                                                    Math.round(trafficUsage.download ? trafficUsage.download : traffic.download),
                                                                    Math.round(trafficUsage.upload ? trafficUsage.upload : traffic.upload),
                                                                ],
                                                                backgroundColor: ['#008DDA', '#41C9E2'],
                                                                borderColor: ['#008DDA', '#41C9E2']
                                                            }
                                                        ]
                                                    }}
                                                    options={{
                                                        responsive: true,
                                                        tooltips: {
                                                            enabled: false
                                                        },
                                                        plugins: {
                                                            legend: {
                                                                position: 'left',
                                                                labels: {
                                                                    usePointStyle: true,
                                                                    pointStyle: 'circle',
                                                                    padding: 20,
                                                                    boxWidth: 5,
                                                                    boxHeight: 5
                                                                },
                                                                rtl: true,
                                                                grace: true
                                                            }
                                                        },
                                                        scales: {}
                                                    }}
                                                />
                                            </div>
                                            <div className="download-upload pl-50 pt-30">
                                                <span>دانلود : {Math.round(trafficUsage?.download ? trafficUsage?.download : traffic?.download) + ' ' + 'گیگ'}</span>
                                                <span>آپلود : {Math.round(trafficUsage?.upload ? trafficUsage?.upload : traffic?.upload) + ' ' + 'گیگ'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div
                            className={`traffic-calculation-type card-body card mb-5 ${
                                activeTab === 'traffic' ? '' : 'd-none'
                            }`}
                        >
                            <div className="traffic-calculation-type-usage">
                                <h2>نسبت استفاده شده</h2>
                                <li className="pt-20">
                                    نسبت استفاده شده
                                    <h5 className="f-extrabold display-inline">
                                        {' ' + trafficInfo?.usage_ratio + ' '}
                                    </h5>
                                    می باشد.
                                </li>
                            </div>
                            <div className="traffic-calculation-type-usage">
                                <h2>نوع محاسبه ترافیک</h2>
                                <li className="pt-20">
                                    ترافیک مصرفی سرویس شما بر اساس حجم{' '}
                                    <h5 className="f-extrabold display-inline">
                                        {' ' + trafficInfo?.traffic_calculation + ' '}
                                    </h5>
                                    محاسبه می گردد
                                </li>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
            <BasicModal open={paymentIsCheckedModal} setOpen={setPaymentIsCheckedModal} headTitle={'وضعیت پرداخت خودکار'}>
                <div className={'w-100'}>
                    <div className={'modal-body'}>
                        <h3>آیا مایل به {paymentIsChecked ? (
                            <span className={'text-danger'}>غیر فعالسازی</span>
                        ) : (
                            <span className={'text-success'}>فعالسازی</span>
                        )} پرداخت خودکار می باشید؟</h3>
                        <p className="mt-5">در صورت فعالسازی این گزینه، مبلغ فاکتور تمدیدی به صورت خودکار از کیف پول شما کسر می گردد.</p>
                        <p className="mt-5">توجه داشته باشید که پرداخت خودکار فاکتور،
                            <span className={'text-warning'}> در زمان سررسید سرویس</span> انجام می شود.</p>
                    </div>
                    <div className="border-top-1 p-4 d-flex align-items-center justify-content-end">
                        <button
                            type="button"
                            className="btn btn-secondary me-4"
                            onClick={()=> setPaymentIsCheckedModal(false)}>
                            انصراف
                        </button>
                        <LoadingButton
                            loadingBtn={loadingBtn}
                            title="تایید درخواست"
                            custom_class="btn-primary"
                            onClick={handleChangeAutomaticPayment}
                        />
                    </div>
                </div>
            </BasicModal>
            {showModal && (
                <div
                    className="modal show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{backgroundColor: "rgba(0,0,0,0.5)"}}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">پلن های خرید ترافیک</h5>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-icon btn-active-color-primary"
                                    aria-label="Close"
                                    onClick={handleShowModal}
                                >
                                    <i className="ki-outline ki-cross fs-1" aria-hidden="true">
                                        x
                                    </i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12">
                                            <TrafficPlanSelector
                                                items={trafficPlan ?? []}
                                                onPlanSelect={handlePlanSelect}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleShowModal}>
                                    بستن
                                </button>
                                <LoadingButton
                                    loadingBtn={loadingBtn}
                                    title="خرید ترافیک"
                                    custom_class="btn-primary"
                                    onClick={handlePurchase}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>

    );
};

export default ServiceDetail;
